import { getQuotes } from "api";

import { Error } from "Responses/Response";
import { ActionTypes } from "./types";

export const GetQuotes = () => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data } = await getQuotes();

    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data
    });
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
